export default __webpack_public_path__ + "static/media/steam.0562ac0e.glb";